/**
 * Registers the production service worker for the learner MFE.
 */

/**
 * Registers `/app/service-worker.js` after load. No-op in development and
 * when service workers are unavailable.
 *
 * @returns {void}
 */
export const registerServiceWorker = () => {
  if (process.env.NODE_ENV !== "production") return;
  if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) return;

  const publicUrl = process.env.PUBLIC_URL || "/app";
  const swUrl = `${publicUrl}/service-worker.js`;
  const scope = publicUrl.endsWith("/") ? publicUrl : `${publicUrl}/`;

  /**
   * Registers the worker and asks the browser to wake us for Background Sync.
   *
   * @returns {void}
   */
  const register = () => {
    navigator.serviceWorker
      .register(swUrl, { scope, updateViaCache: "none" })
      .then((registration) => {
        registration.update().catch(() => {});
        if (registration.sync && typeof registration.sync.register === "function") {
          registration.sync.register("aster-sync").catch(() => {});
        }
      })
      .catch(() => {
        /* registration can fail on HTTP or unsupported browsers */
      });
  };

  if (document.readyState === "complete") register();
  else window.addEventListener("load", register);
};
